import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.boletimbackup.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}


export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}

